import styled, {
  css,
  FlattenInterpolation,
  Interpolation,
  ThemedStyledProps,
} from 'styled-components';
import { isNumber } from 'lodash';

import {
  extractProp,
  extractBooleanProps,
  handleEllipsisProp,
} from '../../../utils/extractProps';
import { fontSize } from '../../../utils/styles';
import { defaultTextStyleProps } from '../constants';
import { TextContainerProps } from '../types';

export const TextStyle = (
  props: TextContainerProps,
  textStyleProps: typeof defaultTextStyleProps = defaultTextStyleProps,
): FlattenInterpolation<ThemedStyledProps<unknown, unknown>> => {
  const { booleanProps, propNames } = textStyleProps(props.theme);

  return css`
    ${handleEllipsisProp(props)};
    ${extractBooleanProps(props, booleanProps)};

    ${propNames.map(propName => extractProp(propName, props, false)).join('')};

    ${isNumber(props.size) ? fontSize(props) : ''};
    ${(props.css || '') as Interpolation<unknown>};
  `;
};

export default styled.span`
  ${TextStyle};
`;
